<template>
  <div class="accordion">
    <b-card no-body class="mb-0 mt-0">
      <b-card-header header-tag="header" role="tab">
        <b-button
          class="text-left d-flex justify-content-between"
          @click="handleCollapse"
          v-b-toggle.accordion-1
          pill
          variant="outline-secondary"
          block
        >
          Mensagem de boas vindas
          <i
            class="icon fa fa-caret-up"
            :class="{'active': collapses.welcome }"
            aria-hidden="true"
          ></i>
        </b-button>
      </b-card-header>
      <b-collapse
        v-model="collapses.welcome"
        id="accordion-1"
        visible
        accordion="accordion-1"
        role="tabpanel"
      >
        <b-card no-body class="mt-0 mb-0">
          <b-card-body class="pt-0">
            <div class="row">
              <div class="col-12">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{'is-filled': !!model.welcome.title }"
                >
                  <label for="welcome_title" class="bmd-label-floating">Título</label>
                  <input
                    refs="welcome_title"
                    id="welcome_title"
                    type="text"
                    class="form-control"
                    v-model="model.welcome.title"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12">
                <quill v-model="model.welcome.text" ref="welcome_text"></quill>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <h6>Legenda</h6>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <small class="d-block">Nome do cliente: {{ legends['cliente.nome'] }}</small>
                <small class="d-block">E-mail do cliente: {{ legends['cliente.email'] }}</small>
                <small class="d-block">CPF ou CNPJ do cliente: {{ legends['cliente.cpf_cnpj'] }}</small>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12">
                <b-form-checkbox v-model="model.welcome.is_automatic">
                    Enviar automaticamente
                </b-form-checkbox>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-collapse>
    </b-card>

    <!-- Data de assembléia -->
    <b-card no-body class="mb-0 mt-0">
      <b-card-header header-tag="header" role="tab">
        <b-button
          class="text-left d-flex justify-content-between"
          @click="handleCollapse"
          v-b-toggle.accordion-2
          pill
          variant="outline-secondary"
          block
        >
          Data de assembléia
          <i
            class="icon fa fa-caret-up"
            :class="{'active': collapses.date_assembly }"
            aria-hidden="true"
          ></i>
        </b-button>
      </b-card-header>
      <b-collapse
        v-model="collapses.date_assembly"
        id="accordion-2"
        visible
        accordion="accordion-2"
        role="tabpanel"
      >
        <b-card no-body class="mt-0 mb-0">
          <b-card-body class="pt-0">
            <div class="row">
              <div class="col-12">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{'is-filled': !!model.date_assembly.title }"
                >
                  <label for="date_assembly_title" class="bmd-label-floating">Título</label>
                  <input
                    refs="date_assembly_title"
                    id="date_assembly_title"
                    type="text"
                    class="form-control"
                    v-model="model.date_assembly.title"
                  />
                </div>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-12">
                <quill ref="date_assembly" v-model="model.date_assembly.text"></quill>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <h6>Legenda</h6>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <small class="d-block">
                  Nome do cliente:
                  <template>{{ legends['cliente.nome'] }}</template>
                </small>
                <small class="d-block">
                  E-mail do cliente:
                  <template>{{ legends['cliente.email'] }}</template>
                </small>
                <small class="d-block">
                  CPF ou CNPJ do cliente:
                  <template>{{ legends['cliente.cpf_cnpj'] }}</template>
                </small>
                <small class="d-block">
                  Data de assembléia:
                  <template>{{ legends['grupo.data_assembleia'] }}</template>
                </small>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12">
                <b-form-checkbox v-model="model.date_assembly.is_automatic">
                    Enviar automaticamente
                </b-form-checkbox>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-collapse>
    </b-card>

    <!-- Data de aniversário -->
    <b-card no-body class="mb-0 mt-0">
      <b-card-header header-tag="header" role="tab">
        <b-button
          class="text-left d-flex justify-content-between"
          @click="handleCollapse"
          v-b-toggle.accordion-3
          pill
          variant="outline-secondary"
          block
        >
          Data de aniversário
          <i
            class="icon fa fa-caret-up"
            :class="{'active': collapses.birth_date }"
            aria-hidden="true"
          ></i>
        </b-button>
      </b-card-header>
      <b-collapse
        v-model="collapses.birth_date"
        id="accordion-3"
        visible
        accordion="accordion-3"
        role="tabpanel"
      >
        <b-card no-body class="mt-0 mb-0">
          <b-card-body class="pt-0">
            <div class="row">
              <div class="col-12">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{'is-filled': !!model.birth_date.title }"
                >
                  <label for="birth_date_title" class="bmd-label-floating">Título</label>
                  <input
                    refs="birth_date_title"
                    id="birth_date_title"
                    type="text"
                    class="form-control"
                    v-model="model.birth_date.title"
                  />
                </div>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-12">
                <quill ref="birth_date" v-model="model.birth_date.text"></quill>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <h6>Legenda</h6>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <small class="d-block">
                  Nome do cliente:
                  <template>{{ legends['cliente.nome'] }}</template>
                </small>
                <small class="d-block">
                  E-mail do cliente:
                  <template>{{ legends['cliente.email'] }}</template>
                </small>
                <small class="d-block">
                  CPF ou CNPJ do cliente:
                  <template>{{ legends['cliente.cpf_cnpj'] }}</template>
                </small>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12">
                <b-form-checkbox v-model="model.birth_date.is_automatic">
                    Enviar automaticamente
                </b-form-checkbox>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-collapse>
    </b-card>

    <!-- Pós vendas -->
    <b-card no-body class="mb-0 mt-0">
      <b-card-header header-tag="header" role="tab">
        <b-button
          class="text-left d-flex justify-content-between"
          @click="handleCollapse"
          v-b-toggle.accordion-4
          pill
          variant="outline-secondary"
          block
        >
          Pós vendas
          <i
            class="icon fa fa-caret-up"
            :class="{'active': collapses.after_sales }"
            aria-hidden="true"
          ></i>
        </b-button>
      </b-card-header>
      <b-collapse
        v-model="collapses.after_sales"
        id="accordion-4"
        visible
        accordion="accordion-4"
        role="tabpanel"
      >
        <b-card no-body class="mt-0 mb-0">
          <b-card-body class="pt-0">
            <div class="row">
              <div class="col-12">
                <div
                  class="form-group bmd-form-group"
                  v-bind:class="{'is-filled': !!model.after_sales.title}"
                >
                  <label for="after_sales_title" class="bmd-label-floating">Título</label>
                  <input
                    refs="after_sales_title"
                    id="after_sales_title"
                    type="text"
                    class="form-control"
                    v-model="model.after_sales.title"
                  />
                </div>
              </div>
            </div>

            <quill ref="date_assembly" v-model="model.after_sales.text"></quill>
          </b-card-body>
        </b-card>
      </b-collapse>
    </b-card>

    <!-- Por parcela -->
    <b-card no-body class="mb-0 mt-0">
      <b-card-header header-tag="header" role="tab">
        <b-button
          class="text-left d-flex justify-content-between"
          @click="handleCollapse"
          v-b-toggle.accordion-5
          pill
          variant="outline-secondary"
          block
        >
          Por parcela
          <i
            class="icon fa fa-caret-up"
            :class="{'active': collapses.per_installment }"
            aria-hidden="true"
          ></i>
        </b-button>
      </b-card-header>

      <b-card-body header-tag="body" class="pt-0" role="tab">
        <b-collapse
          v-model="collapses.per_installment"
          id="accordion-5"
          visible
          accordion="accordion-5"
          role="tabpanel"
        >
          <div class="row">
            <div class="col-12">
              <b-button
                @click.prevent="addInstallment"
                type="submit"
                variant="success"
              >Adicionar parcela</b-button>
            </div>
          </div>
          <hr />

          <div
            class="row position-relative"
            v-for="(installment, index) in model.per_installments"
            :key="index"
          >
            <div class="col-11">
              <div class="row">
                <div class="col-12">
                  <div
                    class="form-group bmd-form-group"
                    v-bind:class="{'is-filled': !!model.per_installments[index].title}"
                  >
                    <label :for="'title-' + index" class="bmd-label-floating">Título</label>
                    <input
                      :id="'title-' + index"
                      type="text"
                      class="form-control"
                      v-model="model.per_installments[index].title"
                    />
                  </div>
                </div>

                <div class="col-12 col-lg-6">
                  <div class="form-group bmd-form-group is-filled">
                    <label
                      class="bmd-label-floating"
                      :for="'installment-' + index"
                    >Parcela {{ installment.installment }}</label>
                    <input
                      :id="'installment-' + index"
                      type="text"
                      class="form-control"
                      v-model="model.per_installments[index].installment"
                    />
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="form-group bmd-form-group is-filled">
                    <label class="bmd-label-floating" :for="'days-' + index">Dias de antecedência</label>
                    <input
                      :id="'days-' + index"
                      type="text"
                      class="form-control"
                      v-model="model.per_installments[index].days"
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group bmd-form-group">
                    <label :for="'text-' + index">Texto</label>

                    <quill
                      :id="'text-' + index"
                      v-model="model.per_installments[index].text"
                    ></quill>
                  </div>
                </div>
              </div>
              <br />
            </div>
            <div class="col-1">
              <b-button-close
                v-b-tooltip.hover
                title="Remover configuração"
                @click.prevent="handleRemoveInstallment(index)"
                type="submit"
                variant="success"
              ></b-button-close>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <h6>Legenda</h6>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <small class="d-block">Nome do cliente: {{ legends['cliente.nome'] }}</small>
              <small class="d-block">E-mail do cliente: {{ legends['cliente.email'] }}</small>
              <small class="d-block">CPF ou CNPJ do cliente: {{ legends['cliente.cpf_cnpj'] }}</small>
              <small class="d-block">Data de assembléia: {{ legends['grupo.data_assembleia'] }}</small>
            </div>
          </div>
        </b-collapse>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import UploadAdapter from "@/components/elements/ckeditor/adapters/UploadAdapter";
import $ from "jquery";
export default {
  computed: {
    model: function () {
      return this.$store.state.configurations.model;
    },
  },
  data() {
    return {
      legends: {
        "cliente.nome": "{{{cliente.nome}}}",
        "cliente.email": "{{{cliente.email}}}",
        "cliente.cpf_cnpj": "{{{cliente.cpf_cnpj}}}",
        "grupo.data_assembleia": "{{{grupo.data_assembleia}}}"
      },
      editor: ClassicEditor,
      editorConfig: {
        // The configuration of the editor.
        extraPlugins: [this.MyCustomUploadAdapterPlugin]
      },
      collapses: {
        welcome: false,
        date_assembly: false,
        birth_date: false,
        after_sales: false,
        per_installment: false
      }
    };
  },
  methods: {
    MyCustomUploadAdapterPlugin(editor) {
      editor.plugins.get("FileRepository").createUploadAdapter = loader => {
        return new UploadAdapter(loader);
      };
    },
    addInstallment(evt) {
      this.model.per_installments.push({
        installment: this.model.per_installments.length + 1,
        text: "",
        days: 1
      });
    },
    handleCollapse(evt) {
      const target = evt.target;
      const icon = $(target).find(".icon");
      if (icon.hasClass("active")) {
        icon.removeClass("active");
      } else {
        icon.addClass("active");
      }
    },
    handleRemoveInstallment(index) {
      this.model.per_installments.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.icon {
  transition: all 0.2s ease-in-out;
  transform: rotate(180deg);
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.icon.active {
  transition: all 0.2s ease-in-out;
  transform: rotate(0);
}
</style>
